import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SalePriceSchedule } from '../models/sale-price-schedule';
import { ConnectionService } from '../../../services/connection/connection.service';
import { SalePriceScheduleService } from './sale-price-schedule.service';
import { catchError, map } from 'rxjs/operators';
import { SalePriceScheduleType } from '../models/sale-price-schedule-type';


@Injectable()
export class SalePriceScheduleOdooService implements SalePriceScheduleService {
  constructor(
    private connectionService: ConnectionService
  ) {
  }

  getAllSalePriceSchedule(): Observable<SalePriceSchedule[]> {
    return this.connectionService.sendJsonPostRequest('/store/salepriceschedule/all_sale_price_schedules', {}).pipe(
      map(result => {
        if (!result) {
          return null;
        }
        return result.map(salePriceSchedule => SalePriceSchedule.createFromAny(salePriceSchedule));
      }),
      catchError(error => {
        return of(null);
      }),
    );
  }

  getAllScheduleTypes(): Observable<SalePriceScheduleType[]> {
    return this.connectionService.sendJsonPostRequest('/store/salepriceschedule/all_schedule_types', {}).pipe(
      map(result => {
        if (!result) {
          return null;
        }
        return result.map(salePriceScheduleType => SalePriceScheduleType.createFromAny(salePriceScheduleType));
      }),
      catchError(error => {
        return of(null);
      }),
    );
  }
}
